import { render } from "./ReportVatPurchaseList.vue?vue&type=template&id=90d27f42&scoped=true"
import script from "./ReportVatPurchaseList.vue?vue&type=script&lang=js"
export * from "./ReportVatPurchaseList.vue?vue&type=script&lang=js"

import "./ReportVatPurchaseList.vue?vue&type=style&index=0&id=90d27f42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d27f42"]])

export default __exports__